/** 工行数币一分钱乘车 - 短信落地页 */
<template>
  <div class="main-box">
    <img
      src="https://oss.aqdpay.com/appweb/aPennyRide/digitalCurrencyForICBC/note/note.png"
      alt=""
    />
  </div>
</template>
<script>
export default {
  name: 'digitalCurrencyForICBCNote'
}
</script>
<style lang="scss" scoped>
.main-box {
  min-height: 100vh;
  background-color: #2cba98;
  img {
    display: flex;
    width: 100%;
    height: auto;
  }
}
</style>
